import { render, staticRenderFns } from "./ModeSwitch.vue?vue&type=template&id=00d6f751"
import script from "./ModeSwitch.vue?vue&type=script&lang=js"
export * from "./ModeSwitch.vue?vue&type=script&lang=js"
import style0 from "./ModeSwitch.vue?vue&type=style&index=0&id=00d6f751&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports